import React from "react";
import "../styles/ResumeModal.css";
import {ResumeModalProps} from "domain/entities";
import {useTheme} from '../providers/ThemeProvider';


const ResumeModal: React.FC<ResumeModalProps> = ({
  isOpen,
  onResume,
  onReset,
}) => {
  if (!isOpen) return null;

    const {theme} = useTheme();
  return (
    <div className="modal-overlay">
      <div className="resume-modal">
        <div className="modal-header">
            <h2 dangerouslySetInnerHTML={{__html: theme?.content.resumeModal.title || ''}}></h2>
        </div>
        <div className="modal-content">
          <p className="modal-text">
              <span className="linea-normal">{theme?.content.resumeModal.messageResume} </span>
          </p>
            <p>{theme?.content.resumeModal.messageRestart}</p>
        </div>
        <div className="modal-actions">
          <button className="btn btn-secondary reset-button" onClick={onReset}>
              {theme?.content.resumeModal.restartButton}
          </button>
          <button className="btn continue-button" onClick={onResume}>
              {theme?.content.resumeModal.resumeButton}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResumeModal;
